import type {ComponentProps} from 'react'

export const ParagraphClasses = 'mb-spacing-12 text-p1'

export const P = ({children}: ComponentProps<'p'>) => (
  <p
    className={ParagraphClasses}
    data-testid={'_p'}
  >
    {children}
  </p>
)
